import React from 'react';
import { FaSearch } from 'react-icons/fa';

function SearchFilter({ searchDate, onSearchChange, viewType }) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <div className="flex items-center gap-4">
        <FaSearch className="text-gray-400" />
        <input
          type="date"
          value={searchDate}
          onChange={(e) => onSearchChange(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 flex-1"
          placeholder="Search by date"
        />
        {searchDate && (
          <button
            onClick={() => onSearchChange('')}
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition"
          >
            ✕ Clear
          </button>
        )}
      </div>
      <p className="text-gray-600 text-sm mt-2">
        {viewType === 'timeline' 
          ? 'Filter entries by date'
          : 'Select a date from the calendar to view entries'}
      </p>
    </div>
  );
}

export default SearchFilter;
